import React from 'react';

import type { FormFields } from '../types';

import { useI18n } from 'lib/i18n/context';
import FormFieldCheckbox from 'ui/shared/forms/fields/FormFieldCheckbox';

import ContractVerificationFormRow from '../ContractVerificationFormRow';
import { CONTRACT_VERIFICATION_FIELD_KEYS } from '../i18n';

const ContractVerificationFieldIsYul = () => {
  const { t } = useI18n();
  return (
    <ContractVerificationFormRow>
      <FormFieldCheckbox<FormFields, 'is_yul'>
        name="is_yul"
        label={ t(CONTRACT_VERIFICATION_FIELD_KEYS.isYul.label) }
      />
    </ContractVerificationFormRow>
  );
};

export default React.memo(ContractVerificationFieldIsYul);
